export default "__VITE_ASSET__6i2s23jR__"